export default "__VITE_ASSET__CfKCnAEA__"